export const platform = {
    labels: {
        code: "Código",
        name: "Nome",
        platform: "Plataforma",
        platforms: "Plataformas",
        description: "Descrição",
        add_platform: "Adicionar Plataforma",
        delete_platform: "Deletar Plataforma",
        groups: "Grupos",
        edit_platform: "Editar Plataforma",
        edit_group: "Editar Grupo",
        slug: "Slug",
    },
    placeholders: {
        code: "Exe: ABC123",
        name: "Informe o nome",
        description: "Informe a descrição",
        slug: "Exe: nome-da-url",
    },
    modals: {
        titles: {
            add_platform: "Adicionar Plataforma",
            del_platform: "Excluir Plataforma",
        },
        messages: {
            del_platform: " Vocês deseja mesmo excluir a plataforma <strong>{name}</strong>?<br/>Todos os relacionamentos desta plataforma serão excluídos.",
        },
    },
    texts: {
        del_platform: "Você deseja mesmo excluir esta plataforma?<br/>Todos os cadastros desta plataforma serão excluídos.",
    },
};
